import React, { Component } from 'react';

class Spinner extends Component {
    render() {
        return (
                <div className={ (this.props.isLoading) ? 'spinner__container is--loading' : 'spinner__container is--loaded'} style={{ position: 'absolute', height: '100%', overflow: 'hidden'}}>
                    <div className="spinner__block">
                        <div className="loader"></div>
                    </div>
                </div>
        );
    }
}

export default Spinner;